import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {
  BehaviorSubject,
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
} from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { CommonValues } from "src/app/services/commonValues";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { JobService } from "src/app/services/job.service";
import { UtilService } from "src/app/services/util.service";
import { User } from "src/app/types/User";
import Swal from "sweetalert2";
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-community-pageadmin",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonSkeletonComponent, NodataFoundComponent, AutocompleteLibModule, TruncatePipe,
InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./community-pageadmin.component.html",
  styleUrls: ["./community-pageadmin.component.scss"],
})
export class CommunityPageadminComponent implements OnInit, OnDestroy {
  @Input() commonemit;
  userId: any;
  adminSearchForm: UntypedFormGroup;
  values: any = {};
  adminType: any;
  modalRef: BsModalRef;
  clickEventsubscription: Subscription;
  businessDetail: any;

  autoCompleteAdminList: any = [];
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    // class: 'modal-md'
  };
  communityId;
  communityAdminList = new BehaviorSubject<any[]>([]);
  commuityLoadScroll: boolean = false;
  communityStopScroll: boolean = false;
  communityPreviouseAfterKey: any = null;
  communitySearchSubject = new Subject<string>();
  communityScrollSubject = new BehaviorSubject<string>(null);

  communitypayload = {
    communityId: null,
    limit: 18,
    status: "ADMIN",
    searchAfterKey: null,
    searchContent: null,
  };

  adminSreach: any;
  serachForm: UntypedFormGroup;
  keyword = "userName";
  item: any;
  pageAdminList = new BehaviorSubject<any[]>([]);
  adminPayload = {
    limit: 10,
    communityId: null,
    searchAfterKey: null,
    searchText: null,
  };
  stopScroll: boolean = false;
  previouseAfterKey: any = null;
  searchSubject = new Subject<string>();
  // Search term typed into the Add Admin ng-select ([typeahead]).
  adminTypeahead = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
  loadScroll: boolean = false;
  selectedFilter: string = "All";
  adminTotal: number = 0;

  admin_data_pop_up;
  removeAdmin_userid;
  removeCommunityId;
  superAdmin_userid;
  isAdmin;
  isSuperAdmin;
  userData = [];
  loginUserId = null;
  makeSuperAdminData = {};
  superadminflag = false;
  colors: Array<any> = ["hgreen", "hred", "horange", "hyellow"];
  tempmadmin: any;
  AdminFilterDatas: any;
  revokedData: any;
  AdminCountData: boolean = false;
  AdminCountRevokeData: boolean = false;
  showNoDatafound: boolean = false;
  revokedDatatemp: any;
  AdminFilterDatastemp: any;
  selectedAdminName: string = '';

  constructor(
    private api: ApiService,
    private commonvalues: CommonValues,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private JobServicecolor: JobService,
    private fb: UntypedFormBuilder,
    private util: UtilService
  ) {
    this.loginUserId = localStorage.getItem("userId");

    this.commonvalues.getbusinessid().subscribe((res) => {
      this.values = res;
    });

    this.isSuperAdmin = localStorage.getItem("isSuperAdmin");
    if (this.isSuperAdmin === "true") {
      this.superadminflag = true;
    } else {
      this.superadminflag = false;
    }

    this.route.queryParams.subscribe((res) => {
      this.communityId = res.communityId;
    });
  }

  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
    this.adminTypeahead.unsubscribe();
    this.scrollSubject.unsubscribe();
    this.communitySearchSubject.unsubscribe();
    this.communityScrollSubject.unsubscribe();
  }

  setFilter(filterName: string) {
    this.selectedFilter = filterName;
    this.communitypayload.status = filterName === "All" ? "ADMIN" : filterName;
    this.resetCommunityAdminPayload();
    this.getadmins();
  }

  ngOnInit() {
    this.values = this.commonemit;
    this.getadmins();
    this.initiate();

    this.handleScrollForAddAdminTemplate();
    this.handleScrollForPageAdminList();
  }

  handleScrollForPageAdminList() {
    this.communitySearchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((res) => {
        this.resetCommunityAdminPayload();
        this.communitypayload.searchContent = res;
        this.getadmins();
      });

    this.communityScrollSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((res) => {
        if (res != null) {
          this.commuityLoadScroll = true;
          this.communitypayload.searchAfterKey =
            this.communityPreviouseAfterKey;
          this.getadmins();
        }
      });
  }

  handleScrollForAddAdminTemplate() {
    // ng-select only emits when the term changes, so no distinctUntilChanged here
    // — it also blocked re-typing the same term after reopening the dialog.
    this.adminTypeahead.subscribe((term) => this.onChangeSearch(term ?? ""));

    this.searchSubject
      .pipe(debounceTime(500))
      .subscribe((res) => {
        this.resetAdminPayload();
        this.adminPayload.searchText = res?.trim() ? res : null;
        this.members();
      });

    this.scrollSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((res) => {
        if (res != null) {
          this.adminPayload.searchAfterKey = this.previouseAfterKey;
          this.members();
        }
      });
  }

  resetAdminPayload() {
    this.adminPayload.searchAfterKey = null;
    this.adminPayload.searchText = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
    this.pageAdminList.next([]);
  }

  resetCommunityAdminPayload() {
    this.communitypayload.searchAfterKey = null;
    this.communitypayload.searchContent = "";
    this.communityPreviouseAfterKey = null;
    this.communityStopScroll = false;
    this.communityAdminList.next([]);
  }

  initiate() {
    this.serachForm = this.fb.group({
      serachData: [null],
    });
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      this.isSuperAdmin = localStorage.getItem("isSuperAdmin");
      if (this.isSuperAdmin === "true") {
        this.superadminflag = true;
      } else {
        this.superadminflag = false;
      }
    }, 700);
  }

  openModal(template: TemplateRef<any>) {
    // Cancel (decline) keeps the last search text in the payload; start clean
    // so the reopened dialog's empty search box shows the full list.
    this.resetAdminPayload();
    // decline() no longer clears the pick, so clear it here: the dropdown is
    // bound to admin_data_pop_up and would reopen showing the old chip.
    this.admin_data_pop_up = null;
    this.members();
    // `gs-add-admin-modal` is the styling hook shared with the Business Add
    // Admin dialog (styles.scss); only this dialog gets it.
    this.modalRef = this.modalService.show(template, {
      ...this.backdropConfig,
      class: 'gs-add-admin-modal',
    });
    this.initiate();
  }

  transferModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }
  superAdmin(template: TemplateRef<any>, data) {
    this.superAdmin_userid = data.userId;
    this.getadmins();
    this.initiate();
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  makeSuperAdminTransfer(template: TemplateRef<any>, data) {
    this.makeSuperAdminData = data;
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  makeSuperAdminTransferAccept() {
    this.superAdmin_userid = this.makeSuperAdminData["userId"];
    this.makeadmin();
  }

  revoke(template: TemplateRef<any>, userId, communityId) {
    this.removeAdmin_userid = userId;
    this.removeCommunityId = communityId;
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  selectEvent(val) {
    this.item = val;
    this.admin_data_pop_up = val;
    this.selectedAdminName = val.userName;
  }

  onChangeSearch(val) {
    // Empty term goes through too, so clearing the text reloads the full list.
    this.searchSubject.next(val);
  }

  selectEventtransfer(val) {
    this.superAdmin_userid = val.userId;
  }

  onScrollDown() {
    console.log("scroll");
    if (!this.stopScroll) {
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }

  decline(): void {
    // this.superAdmin_userid = null;
    // this.admin_data_pop_up = null;
    this.modalRef.hide();
    // this.serachForm.reset();
    // this.resetAdminPayload();
    // this.resetCommunityAdminPayload();
    // this.getadmins();
  }

  close() {
    this.admin_data_pop_up = null;
    this.superAdmin_userid = null;
    this.modalRef.hide();
    this.serachForm.reset();
    this.resetAdminPayload();
    // this.resetCommunityAdminPayload(); 
  }

  cleardata(data) {
    this.admin_data_pop_up = null;
    this.superAdmin_userid = null;
  }

  clearAdminResult(data) {
    this.adminPayload.searchAfterKey = null;
    this.adminPayload.searchText = null;
    this.members();
    this.selectedAdminName = '';
  }

  // Get background color from name
  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  // Get text color from name
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  // Get initials from name
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  filterByString(data, s) {
    return data
      .filter((e) => e.userName.toLowerCase().includes(s))
      .sort((a, b) =>
        a.userName.toLowerCase().includes(s) &&
        !b.userName.toLowerCase().includes(s)
          ? -1
          : b.userName.toLowerCase().includes(s) &&
            !a.userName.toLowerCase().includes(s)
          ? 1
          : 0
      );
  }

  addAdmin() {
    if (
      this.admin_data_pop_up != undefined &&
      this.admin_data_pop_up.userId != undefined &&
      this.admin_data_pop_up.userId != null
    ) {
      let data = {
        communityId: this.communityId,
        userId: this.admin_data_pop_up.userId,
        adminType: "ADMIN",
      };
      this.util.startLoader();
      this.api.create("community/add/admin", data).subscribe(
        (res) => {
          this.util.stopLoader();

          if (res.code == "00000") {
            this.decline();
            // Refresh the admin cards + count (same as remove()); decline() alone only closes the modal.
            this.members();
            this.resetCommunityAdminPayload();
            this.getadmins();
            //   if(this.values.employees.length!=0){
            //     this.decline()
            //   }else{
            //    this.decline()
            //  }
          }
        },
        (err) => {
          this.util.stopLoader();
          if (err.status == 500) {
            this.util.stopLoader();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong while adding admin. Please, try again later.",
              showDenyButton: false,
              confirmButtonText: `ok`,
            });
          }
        }
      );
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please select an admin",
        // showConfirmButton: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  }

  makeadmin() {
    if (this.superAdmin_userid != undefined && this.superAdmin_userid != null) {
      let data = {
        communityId: this.communityId,
        userId: this.superAdmin_userid,
        adminType: "SUPERADMIN",
      };
      this.util.startLoader();
      this.api.create("community/add/admin", data).subscribe(
        (res) => {
          this.util.stopLoader();

          if (res.code == "00000") {
            this.decline();
            // Refresh the admin cards + count (same as remove()); decline() alone only closes the modal.
            this.members();
            this.resetCommunityAdminPayload();
            this.getadmins();
            //   if(this.values.employees.length!=0){
            //     this.decline()
            //   }else{
            //    this.decline()

            //  }
          }
        },
        (err) => {
          this.util.stopLoader();
          if (err.status == 500) {
            this.util.stopLoader();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong while adding admin. Please, try again later.",
              showDenyButton: false,
              confirmButtonText: `ok`,
            });
          }
        }
      );
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please select an admin",
        // showConfirmButton: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  }

  // Accept button shown only when selected filter is REVOKED
  accept(userId) {
    this.util.startLoader();
    let data = {
      communityId: this.communityId,
      userId: userId,
      adminType: "ADMIN",
    };
    this.util.startLoader();
    this.api.create("community/add/admin", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code === "00000") {
          this.util.stopLoader();

          Swal.fire({
            icon: "success",
            title: "Accepted!",
            text: "User accepted successfully.",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            //Remove accepted user from current list (revoked)
            const currentlist = this.communityAdminList.getValue();
            const updatedList = currentlist.filter(
              (users) => users.userId !== userId
            );
            // Update the revoked list
            this.communityAdminList.next(updatedList);
            this.userData = updatedList;

            this.members();
            this.resetCommunityAdminPayload();
            this.getadmins();
          });
        } else {
          this.util.stopLoader();
        }
      },
      (err) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Please try again later.",
          confirmButtonText: `OK`,
          timer: 3000,
        });
        this.util.stopLoader();
      }
    );
  }

  remove() {
    let data = {
      communityId: this.communityId,
      userId: this.removeAdmin_userid,
    };
    this.util.startLoader();
    this.api.create("community/remove/admin", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code === "00000") {
          this.modalRef.hide();
        }
        this.members();
        this.resetCommunityAdminPayload();
        this.getadmins();
      },
      (err) => {
        this.util.stopLoader();
        if (err.status == 500) {
          this.util.stopLoader();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong while processing your request. Please, try again later.",
            showDenyButton: false,
            confirmButtonText: `ok`,
          });
        }
      }
    );
  }

  datas(datas) {
    this.userData = datas;
    this.values.menu = "communitypageadmin";
    this.values.admin = this.userData;
    this.values.membersflage = true;
    this.commonvalues.communitydata(this.values);
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  sortData(data) {
    if (data != null) {
      return data.sort((a, b) => {
        return <any>new Date(b.assignedOn) - <any>new Date(a.assignedOn);
      });
    }
  }

  members() {
    this.loadScroll = true;

    this.adminPayload.communityId = this.communityId;
    this.showNoDatafound = false;

    // clear the array if searchAfterkey is null
    if (this.adminPayload.searchAfterKey === null) {
      this.pageAdminList.next([]);
    }

    this.api
      .create("community/findCommunityAdminSuggestions", this.adminPayload)
      .subscribe(
        (res) => {
          this.datas(this.userData);
          const response = res.data.communityMembers;
          const searchAfteKey = res.data.searchAfterKey;

          if (
            (response && response.length === 0) ||
            JSON.stringify(this.previouseAfterKey) ===
              JSON.stringify(searchAfteKey)
          ) {
            this.stopScroll = true;
            this.loadScroll = false;
          }

          if (response && response.length > 0) {
            const existData = this.pageAdminList.getValue();
            const currentData = response.map((x) => {
              x.userName = x.firstName + " " + x.lastName;
              // No photo → template shows initials (was the userAvatar.png cartoon).
              x.photo =
                x.photo === null || x.photo === undefined || x.photo === ""
                  ? null
                  : AppSettings.photoUrl + x.photo;
              return x;
            });
            const combined = [...existData, ...currentData];
            this.loadScroll = false;
            this.pageAdminList.next(combined);
            this.previouseAfterKey = searchAfteKey;
          }
        },
        (err) => {
          this.util.stopLoader();
        }
      );
  }

  userprofile(data) {
    var userData: any = {};
    userData.userId = data;
    this.router.navigate(["personalProfile"], { queryParams: userData });
  }

  sendmsg(data) {
    var userData: any = {};
    userData.groupId = data.userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }

  sendMessage(user: User) {
    var userData: any = {};
    userData.groupId = user.userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }

  getadmins() {
    this.commuityLoadScroll = true;

    this.autoCompleteAdminList = [];

    this.communitypayload.communityId = this.communityId;
    this.api
      .create("community/findPageAdmins", this.communitypayload)
      .subscribe(
        (res) => {
          if (res.code === GigsumoConstants.SUCESSCODE) {
            const data: any[] = res.data.communityMembersList;
            const searchAfteKey = res.data.searchAfterKey;

            if (
              (data && data.length === 0) ||
              JSON.stringify(this.communityPreviouseAfterKey) ===
                JSON.stringify(searchAfteKey)
            ) {
              this.communityStopScroll = true;
            }

            const exist = this.communityAdminList.getValue();
            const current = data
              .filter((x) => {
                if (this.loginUserId === x.userId) {
                  if (x.type === "SUPERADMIN") {
                    this.superadminflag = true;
                    localStorage.setItem("isSuperAdmin", "true");
                  } else {
                    localStorage.setItem("isSuperAdmin", "false");
                    this.superadminflag = false;
                  }
                }

                return !(
                  this.selectedFilter === "ADMIN" && x.type === "SUPERADMIN"
                );
              })
              .map((element) => {
                let photos;
                if (element.photo == null) {
                  photos = "assets/images/userAvatar.png";
                } else if (element.photo != null) {
                  photos = AppSettings.photoUrl + element.photo;
                }

                let color =
                  this.colors[Math.floor(Math.random() * this.colors.length)];
                let d = {
                  ...element,
                  userName: element.firstName + " " + element.lastName,
                  photos: photos,
                  page: "COMMUNITY",
                  menu: "communitypageadmin",
                  colorVal: color,
                };

                if (this.loginUserId !== element.userId) {
                  this.autoCompleteAdminList.push(d);
                }
                return d;
              });

            this.communityAdminList.next([...exist, ...current]);
            this.communityPreviouseAfterKey = searchAfteKey;

            if (res.data.total) {
              this.adminTotal = this.selectedFilter === "ADMIN" ? (res.data.total - 1) : res.data.total;
            }

            if(this.communityAdminList.getValue().length === 0){
              this.adminTotal = 0;
            }

            this.commuityLoadScroll = false;
          }
        },
        (err) => {
          this.util.stopLoader();
        }
      );
  }

  onSearchCommunity(val: string) {
    this.communitySearchSubject.next(val);
  }

  onScrollCommunity() {
    if (!this.communityStopScroll) {
      this.communityScrollSubject.next(this.communityPreviouseAfterKey);
    }
  }
}

